module.exports = __webpack_public_path__ + "static/media/planning.f3a6d6ef.jpg";